<template>
    <div
        class="nav-wrapper fixed bottom-0 left-0 w-full right-0 z-100 bg-white"
    >
        <button type="button" class="mx-auto table text-error" @click="logOut">{{ $t('Log Out') }}</button>
    </div>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";
export default {
    name: "Logout",
    mixins: [mixins.helpers],
    components: {Button},
    data: function() {
        return {
        };
    },
};
</script>
